import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const AttendanceIndex   = lazy(() => import('../../views/attendance/list'))

const Attendance = [
  {
    path: '/attendance/list',
    element: <AttendanceIndex/>
  }
]

export default Attendance